import dialogEvents from "./EventCenter";
import stuffToSay from "./dialog";
import TalkZone from "./TalkZone";
import Phaser from "phaser";

const externalHost = `https://xelestech.com/`
const category1 = 0b0001
const category2 = 0b0010
const category3 = 0b0100
var collided


function colliderCallback(){
  //console.log('collided');
  collided = true
  //console.log(collided)
}

function colliderEndCallback(){
  console.log('collided end');
  collided = false
  console.log(collided)
}


export default class DialogManager {
  constructor(scene, playerSpine, defaultName,image) {
    scene.load.image('empty_image', `${externalHost}assets/box_invi.png`);
    this.scene = scene;
    this.isTalking = false;

    scene.dialogPlugin.setSettings({
      dialogHeight: 340,
      avatarWidth: 388,
      fontFamily: "Moulpali",
      fontSize: 60,
      atBottom: false,
      frameSettings: {
        key: {
          key: "frames",
          frame: 0
        },
        offsetConfig: 8
      },
      paddings: {
        xPaddingOut: 0,
        yPaddingOut: -300,
        xPaddingIn: 130,
        yPaddingIn: 10
      }
    });

    this.defaultName = defaultName;
    this.currentNpc = null;

    this.talkZone = new TalkZone(scene, 10, 10, playerSpine, defaultName,image);


    //this.npcGroup = scene.matter.add.group();
    //scene.physics.add.overlap(this.talkZone, this.npcGroup);

    dialogEvents.on("wantToTalk", this.wantToTalk, this);
  }

  addNPC(talkerSprite, talkerName) {
    
    var centerX = talkerSprite.x;
    var centerY = talkerSprite.y-150
    var bodies = Phaser.Physics.Matter.Matter.Bodies;
    var bodySensor = bodies.circle(centerX, centerY, 250, { isSensor: true, label: 'npcSensor' });
    var player = this.scene.matter.add.image(centerX, centerY, "empty_image"
    );
    player.setData("npcName", talkerName);
    player.setExistingBody(bodySensor);
    player.setCollisionCategory(category2);
    player.setCollidesWith(category1);
    //var talkzone = new TalkZone(this.scene,100,100,talkerSprite)
    console.log(talkerSprite)
    //this.npcGroup.add(talkerSprite);
  }

  destroy() {
    this.talkZone.destroy();
    this.scene = undefined;
  }


  wantToTalk() {
    this.talkZone.player.setOnCollideActive(colliderCallback)
    this.talkZone.player.setOnCollideEnd(colliderEndCallback)
    //console.log(this.talkZone.player)
    if (this.isTalking) {
      this.isTalking = !this.scene.dialogPlugin.goToNext();

      if (!this.isTalking) {
        this.scene.events.emit("talkingStopped", this.currentNpc);
        this.currentNpc = null;
      }
    } else if(collided) {
      let talker = this.defaultName;
      let npc = this._npcTalking();
      //npc.Bodies.setOnCollideActive(colliderCallback)
      console.log( "npc name" +npc.name)

      if (npc.name !== undefined) {
        talker = npc.name;
        //talker = "tommy"
      }

      this.isTalking = true;
      this.scene.dialogPlugin.startDialog(stuffToSay[talker]);

      this.currentNpc = npc.sprite;
      this.scene.events.emit(
        "talkingStarted",
        npc.isToTheRight,
        this.currentNpc
      );
    }

    //ToDo: Make sure parties look at each other
  }

  _npcTalking() {
    var npc = {};
    var { talkZone } = this;
    var touching
    console.log(this)

    if (talkZone.handleTouch){
      touching = true
    }else{
      touching = false
    }
    
    if (touching) {
      console.log("toching owr")
      npc = {
        sprite: talkZone.lastNpc,
        name: talkZone.getLastNpcName(),
        //isToTheRight: talkZone.isNPCToTheRightOfTalker()
      
      }
    }else{
      console.log("false lsx")
        npc = {
          name : "Tommy"
    }
  }

    return npc;
  }
}
